'use client';

import type { MPAInterceptedResponse } from '@repo/api-gw-sdk';
import { useMemo, useRef } from 'react';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useWorkspace } from '@/contexts/useWorkspace';
import { createMpaInterceptHandler } from './createMpaInterceptHandler';
type MpaInterceptHandler = (payload: MPAInterceptedResponse) => Promise<void>;
export const useMpaInterceptHandler = (): MpaInterceptHandler => {
  const env = useEnvironment();
  const {
    sharedDialog: {
      open: openDialog,
      back: backDialog,
      replace: replaceDialog
    }
  } = useWorkspace();

  // Tracks whether our MPA dialog is currently up. Concurrent intercepts that
  // arrive while one is showing are cancelled. We use a local ref instead of
  // sharedDialog.isOpen so the handler identity doesn't depend on the unstable
  // sharedDialog wrapper object.
  const mpaDialogOpenRef = useRef(false);
  return useMemo(() => createMpaInterceptHandler({
    baseUrl: env.clientApiBaseUrl,
    authToken: env.authToken,
    openDialog,
    backDialog,
    replaceDialog,
    openRef: mpaDialogOpenRef
  }), [env.clientApiBaseUrl, env.authToken, openDialog, backDialog, replaceDialog]);
};